import { SubmitButton } from 'components/SubmitButton'
import styles from './modalMoreInfoCuration.module.scss'
import { ReactComponent as ArrowIcon } from 'images/icons/icon-arrow.svg'

export const MoreInfoModalQuestion: React.FC<any> = ({ handleNext, handheCancel }) => {
  return (
    <div className={styles.container}>
      <h3>Drop Submitted!</h3>

      <span className={styles.text}>
        Drop successfully submitted to the
        <a
          className={styles.textLink}
          target="_blank"
          href="https://curation.poap.xyz/guidelines/policy-and-process/poap-issuer-guidelines"
        >
          {` Curation Body`}
        </a>
        <ArrowIcon />
        {` for review. You will receive a confirmation email from app@poap.xyz.`}
      </span>

      <span className={styles.textInfo}>
        {` To expedite the Curation Body review, you can fill out a form with additional info.`}
      </span>

      <SubmitButton
        text="Complete Form"
        className={styles.btn}
        isSubmitting={false}
        canSubmit={true}
        onClick={handleNext}
        style={{ width: '90%' }}
      />
      <p onClick={handheCancel} className={styles.linkClose}>
        No thanks
      </p>
    </div>
  )
}
